<template>
  <div style="background-color: #f4fbff">
    <Header
            :leftArrow="true"
            :leftText="''"
            @leftClick="onClickLeft"></Header>
    <div class="home home-user tel-room-in">
      <div class="tel-room_inner" >
        <div class="tel-room_cam cam-off" style="height: 300px" v-show="!cameraOpen">
          <p class="cam-off_txt">カメラがオフになっています</p>
        </div>
        <video
          class="cam-off"
          style=" object-fit: cover;border-radius: 5px;height:300px;transform: scaleX(-1);"
          autoplay
          webkit-playsinline
          playsinline
          muted="muted"
          id="myCamera"
          v-show="cameraOpen"
        />
        <div class="tel-room_btn home_menu-area clear">
          <div :class="{ 'tel-room_btn-mic-on': mikeOpen }" class="home_menu-item tel-room_btn-mic" @click="mikeChange">
            <span class="home_menu-txt" v-show="mikeOpen">ON</span>
            <span class="home_menu-txt" v-show="!mikeOpen">OFF</span>
          </div>
          <div :class="{ 'tel-room_btn-video-on': cameraOpen }" class="home_menu-item tel-room_btn-video" @click="cameraChange">
            <span class="home_menu-txt" v-show="cameraOpen">ON</span>
            <span class="home_menu-txt" v-show="!cameraOpen">OFF</span>
          </div>
        </div>
        <van-button class="tel-room_start" @click="checkPermission">開始</van-button>
      </div>
    </div>
    <van-dialog v-model:show="dialogShow" title="チケット必要" show-cancel-button
      @confirm="checkPermission()">
      <div class="dialog-box">
        <div class="input-wrapper">
          <label class="input-label">チケット:</label>
          <input type="text" class="input-field" v-model="ticket">
        </div>
      </div>
    </van-dialog>
<!--    <Footer />-->
  </div>
</template>

<script>
  import Footer from "@/components/Footer.vue";
  import Header from "@/components/Header.vue";
  import {GetRoomDetail, RoomYoteiCheck} from "@/services/room.js";
  import { SaveRoomLog } from "@/services/room";
  import {Dialog, Toast} from "vant";
  import "vant/es/toast/style";

  export default {
  data() {
    return {
      roomInfo: {},
      mikeOpen: false,
      cameraOpen: false,
      id:'',
      room_id:'',
      dialogShow:false,
      ticket:null,
      yotei_id:null,
      mediaStream: null,
      openCameraTime:null,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    this.id = parseInt(this.$route.query.id);
    this.room_id = this.$route.query.room_id;
    this.ticket = this.$route.query.ticket;
    this.yotei_id = this.$route.query.yotei_id;
  },
  beforeUnmount(){
    this.stopNavigator();
  },
  methods: {
    async checkPermission(){
      // 检测是否可以进入房间
      const res = await RoomYoteiCheck({
        room_id: this.room_id,yotei_id:this.yotei_id,ticket:this.ticket
      });
      if(res.data.code >=0){
        const permission = this.checkRoomPermission(res.data.data);
        if(permission !== 'can'){
          this.doErrorPermission(permission,res.data.data);
        }else{
          this.onStart();
        }
      }else{
        Toast.fail('ルームは存在しません。')
      }
    },
    doErrorPermission(permission,data){
      if(permission == 'no-room-permission'){
        // 没有房间权限
        this.dialogAlert("入室許可がありません、\nルーム管理者に連絡してほしい。");
      }else if(permission == 'no-yotei-permission'){
        // 记录预约会议Id 后续比较用
        this.yotei_id = data.yotei_list[0].yotei_id;
        // 没有会议权限 弹出ticket输入框
        this.dialogShow = true;
      }else if(permission == 'wait-yotei'){
        // 会议还没开始
        this.dialogAlert("会議["+data.yotei_list[0].yotei_name+"]は"+
            data.yotei_list[0].yotei_start_time+
            "に開始されます。しばらくお待ちください。");
      }
    },
    dialogAlert(message){
      Dialog.alert({message: message});
    },
    checkRoomPermission(data){
      if(data.yotei_list.length > 0){
        const yotei = data.yotei_list[0];
        // 如果会议进行中，必须要有会议权限
        if (yotei.meeting_status === 'in_progress') {
          // 无会议权限
          if (!yotei.yotei_permission) {
            return 'no-yotei-permission';
          }
          return 'can';
        }
        // 会议未开始时，有房间权限就可以进入
        if (data.room_permission) {
          return 'can';
        }
        // 没有房间权限，检查会议权限
        if (!yotei.yotei_permission) {
          return 'no-yotei-permission';
        }
        // 有会议权限但会议未开始，且无房间权限
        return 'wait-yotei';
      }else{
        // 无预约会议
        return data.room_permission ? 'can' : 'no-room-permission';
      }
    },
    onClickLeft() {
      history.back();
    },
    async stopNavigator() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => {track.stop();});
        this.mediaStream = null;
      }
      const videoElement = document.getElementById("myCamera");
      if (videoElement) {
        videoElement.srcObject = null;
      }
    },
    async getUserMedia() {
      this.openCameraTime = new Date();
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true
        });
        this.mediaStream = stream;
        const videoElement = document.getElementById("myCamera");
        if (videoElement) {
          videoElement.srcObject = stream;
        }
      } catch (error) {
        console.error('Failed to get user media:', error);
        this.cameraOpen = false;
      }
    },
    success(stream) {
      console.log(stream)
      JQuery("#myvideo").get(0).srcObject = stream;
    },
    error(error) {
      console.log(`访问用户媒体设备失败${error.name}, ${error.message}`);
    },
    onStart() {
      const leaveRoomTime = this.$store.state.leaveRoomTime;
      const nowDate = new Date();
      const diffHangUp = Math.floor((nowDate - leaveRoomTime) / 1000);
      if (diffHangUp < 2) {
        Toast.loading({
          message: "",
          forbidClick: true,
          duration: 2000,
        });
        setTimeout(() => {
          this.toRoom();
        }, 2000);
      } else {
        this.toRoom();
      }
    },
    async toRoom() {
      if(this.openCameraTime){
        const currentTime = new Date();
        const diff = Math.abs(currentTime - this.openCameraTime) ;
        if(diff <= 1500){
          // 开启过快的话 需要加一个loading
          setTimeout(async () => {
            await this.stopNavigator();
          }, 1000);
          Toast.loading({
            message: "",
            forbidClick: false,
            duration: 2000,
          });
          this.openCameraTime  = null;
          setTimeout(() => {
            this.toRoom();
          }, 2000);
          return;
        }
      }
      const room_id = this.room_id;
      try {
        const res = await GetRoomDetail(room_id);
        let roomInfo = res.data.data.detail;
        let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
        if (roomInfo && userInfo) {
          // 将摄像头状态传递给下一个页面
          const cameraState = this.cameraOpen;
          this.$router.push({
            path: "/roomConversation",
            query: {id: roomInfo.id, room_id: roomInfo.room_id, mikeOpen: this.mikeOpen,
              cameraOpen: cameraState, yotei_id: this.yotei_id, ticket: this.ticket},
          });
          if (userInfo.type === "4") {
            await SaveRoomLog({doctor_id: userInfo.login_account_id, room_id: roomInfo.room_id, type: "join",});
          }
        }
      }catch (error) {
        console.error('Failed to navigate:', error);
        if(this.cameraOpen){
          await this.getUserMedia();
        }
      }
    },
    mikeChange() {
      this.mikeOpen = !this.mikeOpen;
    },
    async cameraChange() {
      if (!this.cameraOpen) {
        this.cameraOpen = true;
        await this.getUserMedia();
      } else {
        this.cameraOpen = false;
        await this.stopNavigator();
      }
    },
  },
  watch: {},
  computed: {},
};
</script>

<style scoped>
.input-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  margin :20px 30px 40px 30px;
}

.input-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.input-field {
  flex: 1;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
}

.input-field:focus {
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}

.input-field::placeholder {
  color: #999;
}
</style>
